// Conversation list-item strings (auto-merged by lib/i18n.ts).
export const en = {
  'ds.conversation.no_messages': 'No messages',
}

export const zhTW = {
  'ds.conversation.no_messages': '尚無訊息',
}
